var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#003087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.772 75.8769C118.277 90.0042 118.12 108.841 119.103 116.493C116.94 113.353 112.378 104.602 111.434 94.7133C110.254 82.3519 109.665 71.1678 117.333 59.9837C125.002 48.7996 142.109 42.3246 142.699 45.2678C143.171 47.6224 141.322 50.958 140.339 52.3314C133.732 62.6915 128.541 72.3451 126.772 75.8769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.507 103.543C97.8666 129.914 123.625 154.558 136.21 163.584C135.03 163.584 90.1979 147.691 55.9839 116.493C28.6126 91.5347 41.8263 67.2436 51.8546 58.2178C41.9443 95.4197 72.1078 116.1 88.4283 121.791C70.0235 94.4779 70.1414 58.6103 72.501 44.0905C72.501 44.0905 91.3777 37.0269 101.406 36.4383C111.434 35.8496 107.367 47.2199 106.125 49.3883C103.766 53.5087 92.5575 70.5792 95.507 103.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.463 163.584C92.9508 154.362 34.9835 127.442 33.5678 93.536C26.8823 113.942 35.5734 156.52 121.463 163.584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.772 75.8769C118.277 90.0042 118.12 108.841 119.103 116.493C116.94 113.353 112.378 104.602 111.434 94.7133C110.254 82.3519 109.665 71.1678 117.333 59.9837C125.002 48.7996 142.109 42.3246 142.699 45.2678C143.171 47.6224 141.322 50.958 140.339 52.3314C133.732 62.6915 128.541 72.3451 126.772 75.8769Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.507 103.543C97.8666 129.914 123.625 154.558 136.21 163.584C135.03 163.584 90.1979 147.691 55.9839 116.493C28.6126 91.5347 41.8263 67.2436 51.8546 58.2178C41.9443 95.4197 72.1078 116.1 88.4283 121.791C70.0235 94.4779 70.1414 58.6103 72.501 44.0905C72.501 44.0905 91.3777 37.0269 101.406 36.4383C111.434 35.8496 107.367 47.2199 106.125 49.3883C103.766 53.5087 92.5575 70.5792 95.507 103.543Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.463 163.584C92.9508 154.362 34.9835 127.442 33.5678 93.536C26.8823 113.942 35.5734 156.52 121.463 163.584Z",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cdb4a78925cbcc68c1db442053b05e2e.svg";
export { ForwardRef as ReactComponent };